import { render } from "./RequestIDCard.vue?vue&type=template&id=c480aae0&ts=true"
import script from "./RequestIDCard.vue?vue&type=script&lang=ts"
export * from "./RequestIDCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__